import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-sold-to-info',
    templateUrl: './sold-to-info.component.html',
    standalone: false
})
export class SoldToInfoComponent {
  constructor( private dialogRef: MatDialogRef<SoldToInfoComponent>){
    
  }

}
